export default __webpack_public_path__ + "static/media/share-01.f22635ae.svg";